// Shared fetch helper with CSRF token handling
export async function fetchJSON(url, options = {}) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

  const defaults = {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': csrfToken
    }
  }

  if (options.body && typeof options.body === 'object') {
    options.body = JSON.stringify(options.body)
  }

  const response = await fetch(url, { ...defaults, ...options, headers: { ...defaults.headers, ...options.headers } })
  const data = await response.json()

  if (!response.ok && !data.errors) {
    throw new Error(`Request failed with status ${response.status}`)
  }

  return data
}
